import React from 'react';
import {Stack} from '@mui/material';
import {packSx} from 'app/util/packSx/packSx';
import {StyleSx, Sx} from 'app/types/common';
import {DialogClose} from 'app/components/sharedReactComponents/DialogClose/DialogClose';
import {LoadingPlaceholder} from 'app/components/sharedReactComponents/LoadingPlaceholder';
import {router} from 'app/router/main';
import {useTeamBilling} from 'app/components/BillingManager/hooks/useTeamBilling';
import {useFeature, usePairedStatsQuery} from 'app/components/entities/cloud';
import {useCloud} from 'app/components/features/cloud';
import {RegularPairing} from 'app/components/widgets/pairing';

const rootSx: StyleSx = {width: 1032, pl: 3, pr: 1.5};
const pageSx: StyleSx = {mt: 14, flexGrow: 1};

interface Props extends Sx {}

export function OrdinaryPairingPage({sx}: Props) {
  const {team, user} = useCloud();

  const {cloud} = useTeamBilling();
  const usbPairing = useFeature('usb-pairing');

  const teamId = team.id;

  const {data} = usePairedStatsQuery({teamId});

  return (
    <Stack sx={packSx(rootSx, sx)} flexGrow={1} position="relative">
      <DialogClose onClose={() => router.go('devices')} />

      {data ? (
        <RegularPairing
          sx={pageSx}
          teamId={teamId}
          groupAccess={team.caps.groups.enabled}
          usbPairing={usbPairing}
          paired={data.devices}
          permitModifyPlan={user.role.canEditBilling()}
          total={cloud.tier.seats}
          premium={cloud.premium}
        />
      ) : (
        <LoadingPlaceholder />
      )}
    </Stack>
  );
}
